import { random } from "nanoid";

export const getCookie = (name: string) => {
	const cookies =
		typeof window !== "undefined"
			? document.cookie.split(";").reduce((acc: any, cookie) => {
					const [key, value] = cookie.trim().split("=");
					acc[key] = decodeURIComponent(value);
					return acc;
			  }, {})
			: undefined;
	if (cookies !== undefined) return cookies[name];
	return undefined;
};
export const setUniqueIdCookie = () => {
	if (getCookie("1id")) return;
	const date = new Date();
	date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
	const randomUuid = random(30);
	document.cookie = `1id=${randomUuid};expires=${date.toUTCString()};path=/`;
};
